import React, { FC, useContext } from "react";
import { INavLink, INavLinksTree } from "../../type";
import NavItem, { NavItemProps } from "../NavItem/NavItem";

import * as styles from "./NavLink.module.scss";
import classNames from "classnames/bind";
import GeolocationContext from "../../../../utils/localization/geolocation/GeolocationContext";
import { matchesAny } from "../../../../utils/localization/geolocation";
export const cx = classNames.bind(styles);

interface NavLinkBaseProps {
  link: INavLink;
  className?: string;
}

interface NavLinkProps extends NavLinkBaseProps, NavItemProps {
  type?: "link" | "button";
  expandOnMobile?: boolean;
}

const NavLinkBase: FC<NavLinkBaseProps> = ({ link, className }) => {
  const { href, title, newTab = false, children = null } = link;
  const isDropdown = !!children && children.length > 0;

  return (
    // eslint-disable-next-line jsx-a11y/role-supports-aria-props, react/jsx-no-target-blank
    <a
      href={href}
      target={newTab ? "_blank" : ""}
      rel={newTab ? "noreferrer" : undefined}
      className={className}
      aria-haspopup={isDropdown}
      data-content-piece={link["data-content-piece"]}
    >
      {title}
    </a>
  );
};

export const NavLink: FC<NavLinkProps> = ({
  variant,
  link,
  type = "link",
  expandOnMobile = false
}) => {
  const { children = undefined, id = undefined } = link;
  const isDropdown = children && children.length > 0;
  const multiMenu = children && children[0] instanceof Array;
  const submenu: INavLinksTree = (multiMenu
    ? children
    : [children]) as INavLinksTree;
  const geolocation = useContext(GeolocationContext);
  return (
    <NavItem
      variant={variant}
      expandOnMobile={expandOnMobile}
      className={cx({
        navLinkDropdown: isDropdown,
        navLinkAsButton: type == "button"
      })}
      id={id}
    >
      <NavLinkBase link={link} className={cx({})} />
      {children && (
        <div
          className={cx({
            dropdownBody: true,
            dropdownBodyHuge: multiMenu
          })}
          aria-label="submenu"
        >
          {submenu.map((links, count) => (
            <ul key={count}>
              {links
                .filter((link) =>
                  matchesAny(link.filters, geolocation.countryCode)
                )
                .map((l) => (
                  <li key={l.href}>
                    <NavLinkBase link={l} />
                  </li>
                ))}
            </ul>
          ))}
        </div>
      )}
    </NavItem>
  );
};
